import {
  ReceivedInvoiceAiSuggestStatus,
  ReceivedInvoiceAiSuggestStatusProperty,
} from '@/context/services/invoice/type';

/** AI Suggest finished successfully — show the blue success label. */
export const isAiSuggestSuccess = (
  status?: ReceivedInvoiceAiSuggestStatusProperty
): boolean => status === ReceivedInvoiceAiSuggestStatus.success;

/** AI Suggest failed (e.g. OCR failed so AI Suggest failed) — show the yellow alert label. */
export const isAiSuggestFailed = (
  status?: ReceivedInvoiceAiSuggestStatusProperty
): boolean => status === ReceivedInvoiceAiSuggestStatus.failure;

/** Whether an AI Suggest result label should be displayed (success or failure). */
export const hasAiSuggestResult = (
  status?: ReceivedInvoiceAiSuggestStatusProperty
): boolean => isAiSuggestSuccess(status) || isAiSuggestFailed(status);

/** Minimal shape needed to decide the success-without-reference label. */
type AiSuggestionWithReference = {
  status?: ReceivedInvoiceAiSuggestStatusProperty;
  referenced_report?: { number?: string; detail_path?: string } | null;
} | null;

/**
 * AI Suggest finished successfully but returned no reference report — show the
 * plain blue "AIサジェスト" label. Shared by the summary banner (drawers) and the
 * payment-request Edit page so all three surfaces behave identically, including
 * the malformed "object present but no number" payload.
 */
export const isAiSuggestSuccessWithoutReference = (
  aiSuggestion?: AiSuggestionWithReference
): boolean =>
  isAiSuggestSuccess(aiSuggestion?.status) &&
  !aiSuggestion?.referenced_report?.number;

/**
 * AI Suggest is still being computed (queued or actively processing). While
 * this is true the user must not be able to edit, delete, or create a
 * payment request — mirroring the AI OCR processing behavior.
 */
export const isAiSuggestProcessing = (
  status?: ReceivedInvoiceAiSuggestStatusProperty
): boolean =>
  status === ReceivedInvoiceAiSuggestStatus.pending ||
  status === ReceivedInvoiceAiSuggestStatus.processing;
